import api from '../../../../services/api';

const authHeader = () => ({});

// Users
export const getUsers = async () => {
  const res = await api.get('/manager/users', { headers: authHeader() });
  return res.data;
};
export const createUser = async (data) => {
  const res = await api.post('/manager/users', data, { headers: authHeader() });
  return res.data;
};
export const updateUser = async (id, data) => {
  const res = await api.put(`/manager/users/${id}`, data, { headers: authHeader() });
  return res.data;
};
export const deleteUser = async (id) => {
  await api.delete(`/manager/users/${id}`, { headers: authHeader() });
};

// Restaurantes
export const getRestaurantes = async () => {
  const res = await api.get('/manager/restaurantes', { headers: authHeader() });
  return res.data;
};
export const createRestaurante = async (data) => {
  const res = await api.post('/manager/restaurantes', data, { headers: authHeader() });
  return res.data;
};
export const updateRestaurante = async (id, data) => {
  const res = await api.put(`/manager/restaurantes/${id}`, data, { headers: authHeader() });
  return res.data;
};
export const deleteRestaurante = async (id) => {
  await api.delete(`/manager/restaurantes/${id}`, { headers: authHeader() });
};

// Troca de restaurante (retorna novo token e snapshot de sessão)
export const switchRestaurante = async (id) => {
  const res = await api.post(
    '/manager/switch-restaurante',
    { restaurante_id: id },
    { headers: authHeader() }
  );
  return res.data;
};

// Clientes Atendabot
export const getClientes = async (params = {}) => {
  const res = await api.get('/manager/clientes', {
    headers: authHeader(),
    params
  });
  return res.data;
};
export const createCliente = async (data) => {
  const res = await api.post('/manager/clientes', data, { headers: authHeader() });
  return res.data;
};
export const updateCliente = async (id, data) => {
  const res = await api.put(`/manager/clientes/${id}`, data, { headers: authHeader() });
  return res.data;
};
export const deleteCliente = async (id) => {
  await api.delete(`/manager/clientes/${id}`, { headers: authHeader() });
};

// Prospects Atendabot
export const getAtendabotProspects = async (params = {}) => {
  const res = await api.get('/manager/atendabot-prospects', {
    headers: authHeader(),
    params,
  });
  return res.data;
};

export const getAtendabotProspect = async (id) => {
  const res = await api.get(`/manager/atendabot-prospects/${id}`, { headers: authHeader() });
  return res.data;
};

export const createAtendabotProspect = async (data) => {
  const res = await api.post('/manager/atendabot-prospects', data, { headers: authHeader() });
  return res.data;
};

export const updateAtendabotProspect = async (id, data) => {
  const res = await api.put(`/manager/atendabot-prospects/${id}`, data, { headers: authHeader() });
  return res.data;
};

export const deleteAtendabotProspect = async (id) => {
  await api.delete(`/manager/atendabot-prospects/${id}`, { headers: authHeader() });
};

export const importAtendabotProspects = async (items) => {
  const res = await api.post(
    '/manager/atendabot-prospects/import',
    { items },
    { headers: authHeader() },
  );
  return res.data;
};

// Logs
export const getLogs = async (params = {}) => {
  const res = await api.get('/manager/logs', {
    headers: authHeader(),
    params
  });
  return res.data;
};

// Consulta de perfis publicos do Instagram
export const lookupInstagramProfiles = async (profiles) => {
  const res = await api.post('/manager/instagram/profiles', { profiles }, { headers: authHeader() });
  return res.data;
};

export const getInstagramProspects = async (params = {}) => {
  const res = await api.get('/manager/instagram/prospects', {
    headers: authHeader(),
    params,
  });
  return res.data;
};

export const updateInstagramProspectColors = async (username, colors) => {
  const res = await api.patch(
    `/manager/instagram/prospects/${encodeURIComponent(username)}/colors`,
    { colors },
    { headers: authHeader() },
  );
  return res.data;
};

export const updateInstagramProspectChatPrompts = async (username, prompts) => {
  const res = await api.patch(
    `/manager/instagram/prospects/${encodeURIComponent(username)}/chat-prompts`,
    prompts,
    { headers: authHeader() },
  );
  return res.data;
};

export const getWhatsAppPreviewChatPrompts = async () => {
  const res = await api.get('/manager/instagram/preview-chat-prompts', { headers: authHeader() });
  return res.data;
};

export const updateWhatsAppPreviewChatPrompts = async (prompts) => {
  const res = await api.put(
    '/manager/instagram/preview-chat-prompts',
    prompts,
    { headers: authHeader() },
  );
  return res.data;
};

// Promocoes de Billing
export const getBillingProductCatalog = async () => {
  const res = await api.get('/stripe/product-catalog', { headers: authHeader() });
  return res.data;
};

export const getPromotions = async (params = {}) => {
  const res = await api.get('/manager/promotions', {
    headers: authHeader(),
    params,
  });
  return res.data;
};

export const createPromotion = async (data) => {
  const res = await api.post('/manager/promotions', data, { headers: authHeader() });
  return res.data;
};

export const updatePromotionStatus = async (id, status) => {
  const res = await api.patch(
    `/manager/promotions/${id}/status`,
    { status },
    { headers: authHeader() }
  );
  return res.data;
};

// Instancias de WhatsApp (uso interno do Manager)
export const migrateZapiInstance = async (instanceId, action) => {
  const res = await api.post(
    `/manager/zapi/instances/${encodeURIComponent(instanceId)}/migration/${encodeURIComponent(action)}`,
    {},
    { headers: authHeader() },
  );
  return res.data;
};

export const getZapiInstances = async () => {
  const res = await api.get('/manager/zapi/instances', { headers: authHeader() });
  return res.data;
};

export const refreshZapiInstance = async (instanceId) => {
  const res = await api.post(
    `/manager/zapi/instances/${instanceId}/refresh`,
    {},
    { headers: authHeader() },
  );
  return res.data;
};

export const refreshZapiQrCode = async (instanceId) => {
  const res = await api.post(
    `/manager/zapi/instances/${instanceId}/qr-code`,
    {},
    { headers: authHeader() },
  );
  return res.data;
};

export const cancelZapiInstance = async (instanceId) => {
  const res = await api.post(
    `/manager/zapi/instances/${instanceId}/cancel`,
    {},
    { headers: authHeader() },
  );
  return res.data;
};

export const subscribeZapiInstance = async (instanceId) => {
  const res = await api.post(
    `/manager/zapi/instances/${instanceId}/subscribe`,
    {},
    { headers: authHeader() },
  );
  return res.data;
};

export const registerZapiInstance = async (payload) => {
  const res = await api.post('/manager/zapi/instances', payload, { headers: authHeader() });
  return res.data;
};

// Support Bots
export const getSupportBots = async () => {
  const res = await api.get('/manager/bots', { headers: authHeader() });
  return res.data;
};

export const getSupportBotByProduct = async (productKey) => {
  const res = await api.get(`/manager/bots/${productKey}`, { headers: authHeader() });
  return res.data;
};

export const updateSupportBotByProduct = async (productKey, payload) => {
  const res = await api.put(`/manager/bots/${productKey}`, payload, { headers: authHeader() });
  return res.data;
};

export const previewSupportBotByProduct = async (productKey, payload) => {
  const res = await api.post(`/manager/bots/${productKey}/preview`, payload, { headers: authHeader() });
  return res.data;
};

export const uploadSupportBotAvatar = async (productKey, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await api.post(`/manager/bots/${productKey}/avatar`, formData, {
    headers: {
      ...authHeader(),
      'Content-Type': 'multipart/form-data',
    },
  });
  return res.data;
};

// Template global do prompt gerado do Atendabot
export const getAtendabotPromptTemplate = async () => {
  const res = await api.get('/manager/atendabot-prompt-template', { headers: authHeader() });
  return res.data;
};

export const updateAtendabotPromptTemplate = async (content) => {
  const res = await api.put(
    '/manager/atendabot-prompt-template',
    { content },
    { headers: authHeader() },
  );
  return res.data;
};
